jQuery(document).ready(function() {
    console.log("Documentos")
    if(jQuery('.post-type-archive-documento').length ) {
        var windowsize = jQuery(window).width();        
        if (windowsize <= 768) {     
            jQuery('#sidebar').slideToggle();
    
            jQuery('.filter-collapse').click(function(e) {
                e.stopPropagation();
                e.preventDefault();                
                if (e.target !== this)
                    return;
                jQuery('#sidebar').slideToggle();
            });
        }
      
    }
});